import styled, { css } from 'styled-components'
import { BRAND } from '@/shared/brand/brand.config'

const instacartStytchOverrides = css`
  div:has(+ #email-input),
  div:has(+ div > input[name='password']) {
    font-size: 10px;
    line-height: 16px;
    font-weight: 500;
    color: #00000073;
  }

  form > div > div:has(input[name='password']) {
    margin-top: 12px;
  }

  form > div > button[type='submit'] {
    margin-top: 4px;
  }

  #email-input,
  div:has(> input[name='password']),
  input[name='password'] {
    height: 36px;
    font-size: 14px;
  }

  input::placeholder {
    font-size: 14px;
  }

  div:has(> input[name='password']) > button {
    color: #00000040;
  }

  div:has(> input[name='password']) > button svg {
    width: 16px;
    height: 16px;
  }

  button[type='submit'],
  #sso-discovery {
    height: 36px;
    min-height: 36px;
    font-size: 14px;
  }

  #sso-discovery {
    box-shadow: 0px 2px 0px 0px #0000000b;
  }

  #sso-discovery > div {
    margin: 0;
  }

  #sso-discovery > div > :not(span) {
    display: none;
  }

  button[type='submit'] + div {
    margin-top: 10px;
  }

  button[type='submit'] + div > div {
    font-size: 14px;
    font-weight: 400 !important;
  }

  div:has(> div:empty:first-child + div + div:empty:last-child) {
    & > div:empty:first-child {
      margin-right: 10px;
    }

    & > div:empty:last-child {
      margin-left: 10px;
    }

    & > div:not(:empty) {
      font-size: 14px;
      line-height: 1;
    }
  }
`

export const WrapperLogin = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${BRAND.login.pageBackgroundColor};
  min-height: 100vh;
  width: 100%;

  ${BRAND.name === 'instacart' && instacartStytchOverrides}
`
